export default __webpack_public_path__ + "ed8f01ed4ea92ceee8087d234a7c16c7.jpg";